import { connect, useDispatch } from "react-redux";
import { Dispatch, Action } from "redux";
import { CourseInDto } from "../../../../../../../../types/course.dto";
import { Title, SubTitle, Text, Image } from "./styles";
import Typography from "../../../../../../../../components/Typography";
import Link from "../../../../../../../../components/Link";
import Button from "../../../../../../../../components/Button";
import Icon from "../../../../../../../../components/Icon";
import { Center } from "../../../../../../../../components/StyledComponents";
import ArrowRight from "../../../../../../../../assets/icons/icon-cool/outline/Arrows-chevron/Right.svg";
import confettiImage from "../../../../../../../../assets/images/confetti.svg";
import { useEffect, useState } from "react";
import { UserDto } from "../../../../../../../../types/user.dto";
import { updateOneEnrollment } from "../../../../../../../../store/actions/enrollment";
import { useNavigate } from "react-router-dom";

interface ComponentProps {
  course: CourseInDto;
  enrollment;
  currentUnit;
  currentComponent;
  newAnswersQuiz;
  newAnswersQuizStates;
  isLastCourseUnitComponent: boolean;
  nextComponentUrl: string;
  enrollmentEditSates: {
    loading: boolean
    success: boolean
    error: string | boolean
  }
}

const Component = ({
  course,
  enrollment,
  currentUnit,
  currentComponent,
  newAnswersQuiz,
  newAnswersQuizStates,
  isLastCourseUnitComponent,
  nextComponentUrl,
  enrollmentEditSates
}: ComponentProps) => {
  const navigate = useNavigate()
  const dispatch = useDispatch<Dispatch<Action>>();
  const [user, setUser] = useState<UserDto>();

  const handleClick = (): void => {
    navigate(`/dashboard/mis-cursos/${course?.id}/valoration`, { replace: true });
    // if (currentUnit && currentComponent) {
    //   dispatch(
    //     updateOneEnrollment({
    //       idEnrollment: enrollment?.id,
    //       body: {
    //         last_unit_id: currentUnit?.id,
    //         last_component_id: currentComponent?.id,
    //         components_completed: course.total_components,
    //         state: "Finished",
    //         completed_date: new Date(),
    //       },
    //     })
    //   );
    // }
  };

  useEffect(() => {
    const user = sessionStorage.getItem("user");
    if (user) {
      setUser(JSON.parse(user));
    }
  }, []);

  // useEffect(() => {
  //   if (enrollmentEditSates.success && isLastCourseUnitComponent) {
  //     navigate(`/dashboard/mis-cursos/${course?.id}/valoration`, { replace: true });
  //   }
  // }, [enrollmentEditSates, isLastCourseUnitComponent, nextComponentUrl, course])

  return (
    <>
      <div style={{ height: 35 }} />
      <Title>
        ¡Felicitaciones 🚀 <br />
        {`${user?.nombre?.charAt(0)?.toUpperCase()}${user?.nombre?.slice(
          1
        )} ${user?.apellido?.charAt(0)?.toUpperCase()}${user?.apellido?.slice(
          1
        )}`}
        !
        <Image src={confettiImage} alt="" />
      </Title>
      <div style={{ height: 25 }} />
      <SubTitle>Completaste el test satisfactoriamente</SubTitle>

      <Title>Tu puntuación: {newAnswersQuiz?.score}%</Title>
      <div style={{ height: 95 }} />

      <div style={{ height: 45 }} />

      <Center horizontal="center" vertical="center" gap={30}>
        {isLastCourseUnitComponent ? (
          <Button
            options={{ skin: "primary", size: "md", type: "filled" }}
            onClick={handleClick}
          >
            Continuar
          </Button>
        ) : (
          <Link
            options={{ skin: "gray", size: "md", type: "link" }}
            style={{ gap: 8 }}
            href={nextComponentUrl}
          >
            Continuar
            <Icon icon={ArrowRight} size="16px" color={"black"} />
          </Link>
        )}
      </Center>
    </>
  );
};

const state = ({ quizStore, courseStore, enrollmentStore }) => {
  const { data: course, states: courseStates } = courseStore.getOne;
  const { states: enrollmentEditSates } = enrollmentStore.editOne;
  const { data: newAnswersQuiz, states: newAnswersQuizStates } =
    quizStore.newAnswersQuiz;

  return {
    newAnswersQuiz,
    newAnswersQuizStates,
    course,
    courseStates,
    enrollmentEditSates,
  };
};

export default connect(state)(Component);
